export default [
  {
    path: '/veiculos',
    name: 'Veiculos',
    component: () => import('./VeiculosList'),
    meta: {
      domain: 'Veiculos',
      sidebar: true,
      icon: 'directions_boat',
      title: 'Veículos Náuticos',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Veiculos/VeiculosRouter.js